<template>
    <div class="alert alert-danger p-4">
        <div class="font-bold text-xl mb-4">
            Выданные предупреждения
        </div>
        <div class="space-y-3">
            <div v-for="warn in warns" class="flex items-start space-x-2 text-xs">
                <smartdate class="w-20 opacity-50" :date="warn.created_at"></smartdate>
                <div v-html="warn.message"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['warns'],
}
</script>